/* EclatDent — quiz dentifrice : navigation, recommandation, ajout panier, takeover mobile */
(() => {
  if (window.__edqInit) return;
  window.__edqInit = true;

  const root = document.querySelector('[data-edq]');
  if (!root) return;

  const TOTAL = 8;
  let currentStep = 0;
  /** @type {Record<number, string>} */
  let answers = {};

  let images = {};
  const imgNode = root.querySelector('[data-edq-images]');
  if (imgNode) { try { images = JSON.parse(imgNode.textContent || '{}'); } catch (e) { images = {}; } }

  // Textes localisés (labels, fréquences d'abonnement, recommandations) servis par le Liquid
  let I = { labels: {}, freqs: {}, recs: {} };
  const i18nNode = root.querySelector('[data-edq-i18n]');
  if (i18nNode) { try { I = JSON.parse(i18nNode.textContent || '{}'); } catch (e) { /* fallbacks FR ci-dessous */ } }
  const L = I.labels || {};

  // Teinte d'ambiance par goût (question 3)
  const tints = {
    'menthe': 'rgba(34, 197, 94, 0.28)',
    'fruité': 'rgba(236, 72, 153, 0.26)',
    'floral': 'rgba(168, 85, 247, 0.26)',
    'neutre': 'rgba(100, 116, 139, 0.3)',
    'default': 'rgba(74, 144, 226, 0.30)',
  };

  // Plans Club Éclat+ (mêmes IDs que l'ancien quiz)
  const freqs = I.freqs || {};
  const subs = {
    'abonnement-2semaines': { id: '689732714845', freq: freqs['abonnement-2semaines'] || 'toutes les 2 semaines', discount: '10 %' },
    'abonnement-4semaines': { id: '689732747613', freq: freqs['abonnement-4semaines'] || 'toutes les 4 semaines', discount: '10 %' },
    'abonnement-6semaines': { id: '689732780381', freq: freqs['abonnement-6semaines'] || 'toutes les 6 semaines', discount: '10 %' },
  };

  const fill = root.querySelector('[data-edq-fill]');
  const count = root.querySelector('[data-edq-count]');
  const btnBack = root.querySelector('[data-edq-back]');
  const btnNext = root.querySelector('[data-edq-next]');
  const btnQuit = root.querySelector('[data-edq-quit]');

  function showStep(step) {
    root.querySelectorAll('[data-edq-step]').forEach((s) => s.classList.toggle('active', s.dataset.edqStep === String(step)));
    root.scrollTop = 0;
    if (!root.classList.contains('is-takeover')) {
      const top = root.getBoundingClientRect().top + window.scrollY;
      if (Math.abs(window.scrollY - top) > 40 && currentStep !== 0) window.scrollTo({ top, behavior: 'instant' });
    }
  }

  function updateProgress() {
    let pct = 0, label = L.welcome || 'Bienvenue';
    if (currentStep === 'result') { pct = 100; label = L.done || 'Diagnostic terminé ✓'; }
    else if (typeof currentStep === 'number' && currentStep > 0) {
      pct = (currentStep / TOTAL) * 100;
      label = (L.question || 'Question {n} sur {total}').replace('{n}', String(currentStep)).replace('{total}', String(TOTAL));
    }
    if (fill) fill.style.width = pct + '%';
    if (count) count.textContent = label;
  }

  function updateNav() {
    const inQuestions = typeof currentStep === 'number' && currentStep >= 1 && currentStep <= TOTAL;
    if (btnBack) btnBack.hidden = !inQuestions;
    if (btnNext) btnNext.hidden = !(inQuestions && answers[currentStep]);
  }

  function goTo(step) {
    currentStep = step;
    showStep(step);
    updateProgress();
    updateNav();
  }

  // — Takeover plein écran sur mobile —
  function enterTakeover() {
    if (!matchMedia('(max-width: 768px)').matches) return;
    root.classList.add('is-takeover');
    document.documentElement.classList.add('edq-lock');
    if (btnQuit) btnQuit.hidden = false;
  }
  function exitTakeover() {
    root.classList.remove('is-takeover');
    document.documentElement.classList.remove('edq-lock');
    if (btnQuit) btnQuit.hidden = true;
  }
  if (btnQuit) btnQuit.addEventListener('click', exitTakeover);

  const startBtn = root.querySelector('[data-edq-start]');
  if (startBtn) startBtn.addEventListener('click', () => { enterTakeover(); goTo(1); });

  if (btnBack) btnBack.addEventListener('click', () => { if (typeof currentStep === 'number' && currentStep > 0) goTo(currentStep - 1); });
  if (btnNext) btnNext.addEventListener('click', () => {
    if (typeof currentStep !== 'number') return;
    if (currentStep < TOTAL) goTo(currentStep + 1);
    else showResults();
  });

  root.querySelectorAll('[data-edq-option]').forEach((opt) => {
    opt.addEventListener('click', () => {
      const step = Number(opt.dataset.step);
      const value = opt.dataset.value || '';
      answers[step] = value;
      if (step === 3) root.style.setProperty('--edq-tint', tints[value] || tints['default']);
      const container = opt.closest('[data-edq-step]');
      if (container) container.querySelectorAll('.edq-option').forEach((o) => o.classList.remove('selected'));
      opt.classList.add('selected');
      updateNav();
      setTimeout(() => {
        if (currentStep !== step) return; // l'utilisateur a déjà navigué
        if (step < TOTAL) goTo(step + 1);
        else showResults();
      }, 550);
    });
  });

  // — Recommandation : règles identiques à l'ancien quiz —
  // Textes (nom produit localisé, description, bénéfices « a|b|c ») dans le blob i18n.
  function buildRec(recKey, imgKey, fallbackName, variantId) {
    const r = (I.recs || {})[recKey] || {};
    return {
      key: imgKey,
      name: r.name || fallbackName,
      variantId: variantId,
      description: r.desc || '',
      benefits: (r.benefits || '').split('|').filter(Boolean),
    };
  }

  function getRecommendation() {
    const goal = answers[1], habits = answers[2], taste = answers[3];
    const care = answers[5], moment = answers[7], sub = answers[8];
    const withSub = (p) => Object.assign({}, p, { subscription: subs[sub] || null });

    if (habits === 'fumeur') return withSub(buildRec('tabac', 'tabac', 'Anti-Taches Tabac', '57759378440541'));
    if (habits === 'cafe-the') return withSub(buildRec('cafe', 'cafe', 'Anti-Taches Café', '57949688496477'));
    if (goal === 'blancheur') {
      if (taste === 'fruité') return withSub(buildRec('coco', 'coco', 'Blancheur Douceur Coco', '57949692363101'));
      return withSub(buildRec('charbon', 'charbon', 'Charbon Actif Blancheur', '57949681910109'));
    }
    if (taste === 'floral') return withSub(buildRec('sakura', 'sakura', 'Grenade & Fleur de Sakura', '57949690888541'));
    if (taste === 'fruité') return withSub(buildRec('peche', 'peche', 'Pêche & Sel Marin Multi-Action', '57949668737373'));
    if (goal === 'haleine' || moment === 'matin') return withSub(buildRec('menthe', 'menthe', 'Classique Menthe', '57949695607133'));
    if (goal === 'naturel' || care === 'gencives') return withSub(buildRec('selmarin', 'selmarin', 'Sel Marin & Bicarbonate Purifiant', '57949696524637'));
    return withSub(buildRec('peche_default', 'peche', 'Pêche & Sel Marin Multi-Action', '57949668737373'));
  }

  function addToCart(variantId, sellingPlan, qty) {
    const body = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (sellingPlan) body.selling_plan = parseInt(sellingPlan, 10);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error('Erreur HTTP ' + r.status);
      return r.json();
    }).then(() => { exitTakeover(); window.location.href = L.cartUrl || '/cart'; })
      .catch(() => { alert(L.addFail || "Impossible d'ajouter au panier. Réessaie dans un instant."); });
  }

  function showResults() {
    goTo('result');
    const rec = getRecommendation();

    const img = root.querySelector('[data-edq-img]');
    if (img) {
      if (images[rec.key]) { img.src = images[rec.key]; img.alt = rec.name; }
      else { img.remove(); }
    }
    const name = root.querySelector('[data-edq-name]');
    if (name) name.textContent = rec.name;
    const desc = root.querySelector('[data-edq-desc]');
    if (desc) desc.textContent = rec.description;
    const benefits = root.querySelector('[data-edq-benefits]');
    if (benefits) {
      benefits.innerHTML = '';
      rec.benefits.forEach((b) => {
        const chip = document.createElement('span');
        chip.textContent = b;
        benefits.appendChild(chip);
      });
    }

    const ctaSub = root.querySelector('[data-edq-cta-sub]');
    const ctaSolo = root.querySelector('[data-edq-cta-solo]');
    const ctaX2 = root.querySelector('[data-edq-cta-x2]');
    if (rec.subscription) {
      if (ctaSub) {
        ctaSub.hidden = false;
        ctaSub.textContent = (L.subCta || "🎁 S'abonner {freq} (−{discount})")
          .replace('{freq}', rec.subscription.freq)
          .replace('{discount}', rec.subscription.discount);
        ctaSub.onclick = () => addToCart(rec.variantId, rec.subscription.id);
      }
      if (ctaX2) ctaX2.hidden = true;
      if (ctaSolo) { ctaSolo.textContent = L.soloSub || 'Achat unique'; ctaSolo.onclick = () => addToCart(rec.variantId, null); }
    } else {
      if (ctaSub) ctaSub.hidden = true;
      if (ctaX2) { ctaX2.hidden = false; ctaX2.onclick = () => addToCart(rec.variantId, null, 2); }
      if (ctaSolo) { ctaSolo.textContent = L.soloOne || 'Commander 1 tube'; ctaSolo.onclick = () => addToCart(rec.variantId, null); }
    }
  }

  const restart = root.querySelector('[data-edq-restart]');
  if (restart) restart.addEventListener('click', () => {
    answers = {};
    root.style.setProperty('--edq-tint', tints['default']);
    root.querySelectorAll('.edq-option').forEach((o) => o.classList.remove('selected'));
    goTo(0);
  });

  updateProgress();
  updateNav();
})();
